import React from 'react';
import { Google, Apple } from '../../SVGs/Icons';

const GoogleIcon = () => (
    <>
        <div className='flex rounded-lg w-30 lg:w-40 border border-headingDark border-opacity-10 cursor-pointer bg-secondary'>
            <div className='w-1/3 flex justify-center items-center'> <Google /> </div>
            <a href='https://play.google.com/store/apps/details?id=com.edveslimited.edvesapp' target="_blank py-1 w-2/3">
                <div className='flex flex-col'>
                    <span className='text-xs space-y-0.5 uppercase'> Get it on </span>
                    <span className='text-sm font-semibold'> Google Play </span>                
                </div>
            </a>
        </div>
    </> 
);

const AppleIcon = () => (
    <>
        <div className='flex rounded-lg w-40 border border-headingDark border-opacity-10 cursor-pointer bg-secondary'>
            <div className='w-1/3 flex justify-center items-center'> <Apple /> </div>
            <div className='flex flex-col w-2/3 py-1'>
                <span className='text-xs space-y-1'>  Download on the </span>
                <span className='text-p font-semibold'> Apple Store </span>                
            </div>
        </div>
    </>
); 

export { GoogleIcon, AppleIcon };